import { CMEActivityLogContainer } from "@features/cme/containers/CMEActivityLogContainer";
import { AppBar } from "@features/dashboard/layouts/AppBar";
import { handleNavigateBack } from "@helpers/common";
import DocumentTitle from "components/DocumentTitle";

const CMEActivityLogRoute = () => {
	const title = "Activity Log";

	return (
		<>
			<DocumentTitle title={title} />
			<AppBar title={title} onPressBack={() => handleNavigateBack("/cme")} />
			<CMEActivityLogContainer />
		</>
	);
};

export default CMEActivityLogRoute;
